import { App, AppState } from '@capacitor/app';
import { storeToRefs } from 'pinia';
import { useExperiencePlayerStore } from '@/core/store/experience-player.ts';

let shouldBeResumed = false;

export const CapacitorListenersPlugin = {
  install() {
    App.addListener('appStateChange', (state: AppState) => {
      const experiencePlayerStore = useExperiencePlayerStore();

      const {
        play: playExperience,
        pause: pauseExperience,
      } = experiencePlayerStore;

      const { isPaused } = storeToRefs(useExperiencePlayerStore());

      if (!state.isActive) {
        if (!isPaused.value) {
          shouldBeResumed = true;
        }

        pauseExperience();

        // Manually go through all players to pause them to avoid players continue playing when stupid watchers are not fired
        (document.querySelectorAll('audio, video') as NodeListOf<HTMLAudioElement | HTMLVideoElement>).forEach((el) => {
          el.pause();
        });
      }

      if (state.isActive) {
        if (shouldBeResumed) {
          playExperience();
        }

        shouldBeResumed = false;
      }
    });
  },
};
